import { useState } from "react"
import "./style.scss"

const FaqItem = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)

  return (<div className={`faq-item ${isOpen ? 'open' : ''}`} onClick={() => toggle()}>
    <div className="indicator"></div>
    {children}
  </div>)
}

const FAQ = ({ language = 'en' }) => (
  <div className="faq flex flex-column">
    {language === 'en' &&
      <h2>FAQ</h2>
    }
    {language === 'de' &&
      <h2>FAQ</h2>
    }
    {language === 'en' &&
      <>
        <FaqItem>
          <h3>How does an AI chat bot work in mental health support?</h3>
          <p>An AI chat bot uses artificial intelligence to understand and support you in mental health care while ensuring security and protecting your health information. It fosters human connection by allowing you to talk to it anytime, remembering past conversations to make interactions more personal. Using machines and chatbots, it pays attention to your voice or video, tracks patterns in how you type or move, and even considers how sleep and weather affect you. It responds in real time, provides guidance, and tracks progress—all while feeling like a natural conversation.</p>
        </FaqItem>

        <FaqItem>
          <h3>Can an AI chat bot replace a psychologist?</h3>
          <p>No, AI cannot replace psychologists or other human therapists. An AI chat bot is not a medical professional. However, it offers instant support—whether you&apos;re between psychotherapists or don&apos;t have access to a therapist. Earkick's advice uses principles from Cognitive Behavioral Therapy (CBT) and Dialectical Behavior Therapy (DBT) to provide evidence-based suggestions and practical tools for patients to manage emotions and stress.</p>
        </FaqItem>

        <FaqItem>
          <h3>Can Earkick diagnose mental health conditions?</h3>
          <p>No, Earkick is not intended to provide formal diagnoses, medical advice, or replace traditional therapy or clinical evaluations. Instead, it analyzes trends and helps you track your emotions, spot patterns, and manage stress by offering mental advice. If you are experiencing a mental health crisis, struggling with thoughts of suicide, or in need of a diagnosis, seek help from the mental health professionals. Earkick aligns with guidelines from organizations like the <a href="https://www.apa.org/research-practice/standards-guidelines" target="_blank" rel="noreferer">American Psychological Association</a> but should not be used as a substitute for professional care.</p>
        </FaqItem>

        <FaqItem>
          <h3>What does the free version of an app offer?</h3>
          <p>The free version of Earkick offers a safe place to chat with Panda, vent, feel heard and get actionable suggestions. You can personalize your Panda, get daily checkins, weekly summaries of your progress, and statistics to stay in control of your journey. The habit tracker, CBT sessions, daily quotes and the knowledge hub help your personal growth. You get breathing exercises for immediate relief and soundscapes for meditation or sleep.</p>
        </FaqItem>

        <FaqItem>
          <h3>How much does Earkick cost? </h3>
          <p>Earkick offers a free trial and you don&apos;t have to register to start. The premium version&apos;s prices depend on your location. We offer annual and monthly subscriptions including a family plan so the whole family can benefit. <a href="https://apps.apple.com/us/app/id1584854531" target="_blank" rel="noreferrer">Start Earkick for free on the App Store</a>!</p>
        </FaqItem>

        <FaqItem>
          <h3>Can Earkick personalize its therapy advice?</h3>
          <p>Yes! Earkick remembers your conversations and learns from how you interact with it. Its responses and suggestions are tailored to fit your needs. You can also customize your Earkick Panda&apos;s personality and conversation style to match your preferences.</p>
        </FaqItem>

        <FaqItem>
          <h3>If you are already seeing a licensed therapist, can Earkick help you?</h3>
          <p>Yes! An AI application is a great tool in between therapy sessions. Earkick reinforces what you&apos;re working on, supporting your treatment by providing encouragement and motivation when you need it most. With 24/7 support, you can practice coping strategies, track your experiences, and make your therapy even more effective. It can also assist individuals with autism by offering structured guidance and personalized support.</p>
        </FaqItem>

        <FaqItem>
          <h3>Does Earkick give objective guidance and unbiased care?</h3>
          <p>Yes. Earkick&apos;s algorithms are built on proven mental health methods and continuously refined to minimize bias. Its data-driven guidance supports your mental health journey by providing non-judgmental and unbiased emotional support. With the ability to learn from real interactions and user feedback, it continuously improves to better meet your needs.</p>
        </FaqItem>

        <FaqItem>
          <h3>What mental health issues can Earkick help with?</h3>
          <p>Earkick AI chat bot helps with stress, anxiety, motivation, sleep, focus, negative self-talk, emotional regulation, relationships and self-confidence.</p>
        </FaqItem>
      </>
    }
    {language === 'de' &&
      <>
        <FaqItem>
          <h3>Wie funktioniert eine KI-Therapie-App?</h3>
          <p>Eine KI-Therapie-App nutzt künstliche Intelligenz, um dich in deiner mentalen Gesundheit zu begleiten und zu unterstützen. Dabei achtet sie auf Sicherheit und schützt deine Daten. Du kannst jederzeit mit der KI sprechen. Sie erinnert sich an frühere Gespräche und kann dich dadurch persönlicher begleiten. Sie erkennt Muster in deiner Stimme, deinem Verhalten, deiner Bewegung sowie Einflüsse wie Schlaf oder Wetter. Die App interagiert in Echtzeit, gibt dir Orientierung und unterstützt dich wie in einem natürlichen Gespräch.</p>
        </FaqItem>

        <FaqItem>
          <h3>Kann ein KI-Chatbot Psychologen ersetzen?</h3>
          <p>Nein, eine KI kann keine Psychologen oder Therapeuten ersetzen. Sie ist kein medizinischer Profi. Aber sie bietet sofortige Unterstützung, besonders wenn du gerade keine Therapie machst oder keinen Zugang zu einer Fachperson hast. Die Anregungen von Earkick basieren auf Methoden der kognitiven Verhaltenstherapie (CBT) und der dialektisch-behavioralen Therapie (DBT) und helfen dir, besser mit Stress und Emotionen umzugehen.</p>
        </FaqItem>

        <FaqItem>
          <h3>Kann Earkick psychische Erkrankungen diagnostizieren?</h3>
          <p>Nein, Earkick stellt keine Diagnosen und ersetzt keine Therapie. Die App hilft dir, emotionale Muster zu erkennen, deine Gefühle besser zu verstehen und Stress zu bewältigen. Wenn du in einer Krise bist, Suizidgedanken hast oder eine Diagnose brauchst, wende dich an Fachpersonal. Earkick orientiert sich an anerkannten Leitlinien, ist aber kein Ersatz für professionelle Hilfe.
          </p>
        </FaqItem>

        <FaqItem>
          <h3>
            Was bietet die kostenlose Version der App?
          </h3>
          <p>Du kannst mit Panda chatten, dich aussprechen, dich verstanden fühlen und bekommst hilfreiche Anregungen. Du kannst Panda deinen eigenen Vorstellungen entsprechend gestalten. Außerdem helfen dir tägliche Check-ins, Wochenübersichten und Statistiken, um deinen Fortschritt jederzeit im Blick zu behalten. Auch der Habit-Tracker, CBT-Sessions, tägliche Zitate, ein Wissensbereich, Atemübungen und beruhigende Klänge stehen dir zur Verfügung.</p>
        </FaqItem>

        <FaqItem>
          <h3>Was kostet Earkick?</h3>
          <p>Earkick bietet eine kostenlose Testversion und du musst dich nicht registrieren um zu starten. Für die Premium-Version gibt es Monats- und Jahresabos sowie einen Familienplan. Die Preise richten sich nach deinem Standort.
          </p>
        </FaqItem>

        <FaqItem>
          <h3>Kann Earkick persönliche Anregungen geben?</h3>
          <p>Ja. Earkick merkt sich deine Gespräche und passt Anregungen und Antworten an dich an. Du kannst die Persönlichkeit und den Stil deines Pandas deinen Vorlieben entsprechend anpassen.</p>
        </FaqItem>

        <FaqItem>
          <h3>Wenn ich bereits in Therapie bin – kann Earkick trotzdem helfen?</h3>
          <p>Ja. Earkick ist eine gute Ergänzung zwischen den Sitzungen. Die App erinnert dich an deine Ziele, motiviert dich und hilft dir, Tools aus der Therapie im Alltag anzuwenden. Auch für Menschen im Autismus-Spektrum kann Earkick durch klare Strukturen und persönliche Begleitung eine wirkungsvolle Unterstützung sein.</p>
        </FaqItem>

        <FaqItem>
          <h3>Gibt Earkick objektive und neutrale Anregungen?
          </h3>
          <p>Ja. Die Anregungen basieren auf bewährten Methoden der psychischen Gesundheit. Sie sind datenbasiert, nicht wertend und passen sich deinen Bedürfnissen an. Earkick lernt aus echten Gesprächen und verbessert sich kontinuierlich.</p>
        </FaqItem>

        <FaqItem>
          <h3>Bei welchen Themen kann Earkick helfen?</h3>
          <p>Earkick unterstützt dich bei Stress, Angst, Schlafproblemen, Motivation, Konzentration, negativem Selbstbild, Emotionsregulation, Beziehungen und Selbstvertrauen.</p>
        </FaqItem>
      </>
    }
  </div>
)

export default FAQ
